export const BUG_SNAG_MI_TRADE_API_KEY = "1b16bfe0a315d760a67db5ee55c048ad";
